import { Gender, MerchantUserDto, MerchantUserType } from "@/models/club";
import { Skeleton, Stack, Text } from "@mantine/core";
import { IconCircleFilled } from "@tabler/icons-react";
import moment from "moment-jalaali";

type Props = {
  user: MerchantUserDto;
  isLoading: boolean;
};

function ProfileDetail({ user, isLoading }: Props) {
  return (
    <Stack gap="xl">
      <Stack gap="5">
        <Text fw="600" size="sm">
          نام و نام خانوادگی
        </Text>
        <Text c="dark.5" size="sm">
          {isLoading ? (
            <Skeleton w="150px" height={20} />
          ) : (
            <>
              {user?.firstName} {user?.lastName}
            </>
          )}
        </Text>
      </Stack>
      <Stack gap="5">
        <Text fw="600" size="sm">
          عنوان شغلی{" "}
        </Text>
        <Text c="dark.5" size="sm">
          {isLoading ? (
            <Skeleton w="150px" height={20} />
          ) : (
            <>{user?.jobTitle || "-"}</>
          )}
        </Text>
      </Stack>

      <Stack gap="5">
        <Text fw="600" size="sm">
          شماره تلفن
        </Text>
        <Text c="dark.5" size="sm">
          {isLoading ? (
            <Skeleton w="100px" height={20} />
          ) : (
            <>{user?.phoneNumber}</>
          )}
        </Text>
      </Stack>
      <Stack gap="5">
        <Text fw="600" size="sm">
          {" "}
          جنیسیت
        </Text>
        <Text c="dark.5" size="sm">
          {isLoading ? (
            <Skeleton w="100px" height={20} />
          ) : (
            <>{user?.gender === Gender.Value0 ? "مرد" : "خانم"}</>
          )}
        </Text>
      </Stack>

      <Stack gap="5">
        <Text fw="600" size="sm">
          {" "}
          تاریخ تولد
        </Text>
        <Text c="dark.5" size="sm">
          {isLoading ? (
            <Skeleton w="150px" height={20} />
          ) : (
            <>
              {user?.birthDate
                ? moment(user?.birthDate).format("jDD jMMMM ,jYYYY")
                : "-"}
            </>
          )}
        </Text>
      </Stack>
      <Stack gap="5">
        <Text fw="600" size="sm">
          {" "}
          سطح دسترسی
        </Text>
        <Text c="dark.5" size="sm">
          {isLoading ? (
            <Skeleton w="150px" height={20} />
          ) : (
            <>
              {user?.merchantUserType === MerchantUserType.Value2
                ? "آرایشگر"
                : "دسترسی کامل"}
            </>
          )}
        </Text>
      </Stack>

      <Stack gap="5">
        <Text fw="600" size="sm">
          {" "}
          رنگ تقویمی
        </Text>
        {isLoading ? (
          <Skeleton w="30px" height={30} radius="100px" />
        ) : (
          <>
            <IconCircleFilled color={user?.calendarColor || ""} size={30} />
          </>
        )}
      </Stack>
    </Stack>
  );
}

export default ProfileDetail;
